export const COLUMN_MAP = {
  applications: "applicationID",
  informationRequests: "informationRequestID",
  verifyExternal: "verifyExternalUUID",
} as const;
